import { Injectable } from '@angular/core';
import {
    MatLegacySnackBar as MatSnackBar,
    MatLegacySnackBarHorizontalPosition as MatSnackBarHorizontalPosition,
    MatLegacySnackBarVerticalPosition as MatSnackBarVerticalPosition,
} from '@angular/material/legacy-snack-bar';
import { PopupSnackbarComponent } from './popup.component';

export interface PopupData {
    msg: string;
    icon?: 'info' | 'error' | 'check_circle_outline' | 'warning' | string;
}

export interface PopupOptions {
    durationMs?: number;
    horizontalPosition?: MatSnackBarHorizontalPosition;
    verticalPosition?: MatSnackBarVerticalPosition;
    type?: 'success' | 'neutral' | 'error';
    icon?: PopupData['icon'];
}

@Injectable()
export class PopupService {
    constructor(private snackBar: MatSnackBar) {}

    success(msg: string, options: PopupOptions = {}) {
        return this.snackBar.open(msg, null, {
            panelClass: ['csms-popup', 'popup-success'],
            duration: options.durationMs || 3000,
            horizontalPosition: options.horizontalPosition || 'right',
            verticalPosition: options.verticalPosition || 'bottom',
        });
    }

    neutral(msg: string, options: PopupOptions = {}) {
        return this.snackBar.open(msg, null, {
            panelClass: ['csms-popup', 'popup-neutral'],
            duration: options.durationMs || 3000,
            horizontalPosition: options.horizontalPosition || 'right',
            verticalPosition: options.verticalPosition || 'bottom',
        });
    }

    error(msg: string, options: PopupOptions = {}) {
        return this.snackBar.open(msg, 'X', {
            panelClass: ['csms-popup', 'popup-error'],
            duration: options.durationMs || null,
            horizontalPosition: options.horizontalPosition || 'right',
            verticalPosition: options.verticalPosition || 'bottom',
        });
    }

    open(msg: string, options: PopupOptions = {}) {
        return this.snackBar.openFromComponent(PopupSnackbarComponent, {
            data: { msg, icon: options.icon },
            panelClass: ['csms-popup', `popup-${options.type || 'neutral'}`],
            duration: options.durationMs || 3000,
            horizontalPosition: options.horizontalPosition || 'right',
            verticalPosition: options.verticalPosition || 'bottom',
        });
    }

    dismiss() {
        this.snackBar.dismiss();
    }
}
